import { faX } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useRef } from 'react'

export default function Modal({
  openModal,
  closeModal,
  children,
  wide = false,
  showWrapper = false,
  customClass = '',
  fullscreen = false,
  showCloseButton = false
}: {
  openModal: boolean
  closeModal: () => void
  wide?: boolean
  children: React.ReactNode
  showWrapper?: boolean
  customClass?: string
  fullscreen?: boolean
  showCloseButton?: boolean
}) {
  const ref = useRef<HTMLDialogElement | null>(null)

  useEffect(() => {
    if (openModal) {
      ref.current?.showModal()
    } else {
      ref.current?.close()
    }
  }, [openModal])

  let cn =
    'px-5 md:px-10 relative max-h-[90dvh] overflow-y-auto py-10 mt-10 mb-10 ' +
    customClass
  if (fullscreen) {
    cn += ' w-full h-full '
  }
  if (!fullscreen) {
    cn += ' modal-box '
  }
  if (wide) {
    cn += ' wide '
  }
  const tryClose = (e: React.MouseEvent) => {
    if (e.target === ref.current) {
      closeModal()
    }
  }
  return (
    <>
      <dialog
        ref={ref}
        className="modal backdrop-blur-lg backdrop-brightness-50"
        onClose={closeModal}
        onClick={tryClose}
      >
        {showWrapper && (
          <div className={cn}>
            {showCloseButton && (
              <button
                onClick={closeModal}
                className="btn btn-square rounded-lg btn-sm text-lg absolute right-5 top-5"
              >
                <FontAwesomeIcon icon={faX} />
              </button>
            )}
            {children}
          </div>
        )}
        {!showWrapper && children}
      </dialog>
    </>
  )
}
